import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/GetApp';
import AddIcon from '@mui/icons-material/Add';
import { GridOn } from '@mui/icons-material';

const Tallas = () => {
      // Exportar Excel
      const exportExcel = () => {
        (async () => {
          const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
          const filtered = tallas.filter(talla => talla.nombre.toLowerCase().includes(searchValue.toLowerCase()));
          const rows = (rowsPerPage === -1 ? filtered : filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
            .map(talla => ({ id: talla.id, nombre: talla.nombre }));
          await exportGenericWorkbook({
            titulo: 'REPORTE - TALLAS',
            sheetName: 'Tallas',
            tableName: 'tblTallas',
            fileName: 'Tallas',
            columns: [
              { key: 'id', label: 'ID', width: 8 },
              { key: 'nombre', label: 'Nombre', width: 30 }
            ],
            rows,
            searchText: searchValue,
            usuario: ''
          });
        })();
      };
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
  const [tallas, setTallas] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nombre, setNombre] = useState('');

  const fetchTallas = async () => {
    const res = await axios.get('/api/tallas');
    setTallas(res.data);
  };

  useEffect(() => {
    fetchTallas();
  }, []);

  const handleOpen = (talla = null) => {
    if (talla) {
      setEditId(talla.id);
      setNombre(talla.nombre);
    } else {
      setEditId(null);
      setNombre('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setNombre('');
  };

  const handleSave = async () => {
    if (!nombre) return;
    try {
      if (editId) {
        await axios.put(`/api/tallas/${editId}`, { nombre });
      } else {
        await axios.post('/api/tallas', { nombre });
      }
      fetchTallas();
      handleClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/tallas/${id}`);
      fetchTallas();
    } catch { alert('Error al eliminar'); }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800 }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Tallas</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField size="small" label="Buscar" value={searchValue} onChange={e => { setSearchValue(e.target.value); setPage(0); }} sx={{ flex: 1 }} />
          <Button color="success" variant="contained" startIcon={<GridOn />} sx={{ minWidth: 120 }} onClick={exportExcel}>Exportar Excel</Button>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nueva Talla</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ pr: 8 }}>ID</TableCell>
                <TableCell align="center">Nombre</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tallas
                .filter(talla => talla.nombre.toLowerCase().includes(searchValue.toLowerCase()))
                .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
                .map((talla) => (
                  <TableRow key={talla.id}>
                    <TableCell align="center" sx={{ pr: 8 }}>{talla.id}</TableCell>
                    <TableCell align="center">{talla.nombre}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleOpen(talla)}><EditIcon /></IconButton>
                      <IconButton color="error" onClick={() => handleDelete(talla.id)}><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginacionControl
          page={page}
          rowsPerPage={rowsPerPage}
          count={tallas.filter(talla => talla.nombre.toLowerCase().includes(searchValue.toLowerCase())).length}
          onPageChange={setPage}
        />
        <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Typography variant="h5" fontWeight="bold">
              {editId ? 'Editar Talla' : 'Nueva Talla'}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Nombre"
              fullWidth
              value={nombre}
              onChange={e => setNombre(e.target.value)}
              sx={{ mb: 2 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
            <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Tallas;
